(function(){if(window.__witsPP2Extras)return;window.__witsPP2Extras=1;
(function(){var qs=document.getElementById('qslide'),qd=[].slice.call(document.querySelectorAll('#qdots i'));if(!qs)return;
var orig=[].slice.call(qs.children),n=orig.length;
orig.forEach(function(c){qs.appendChild(c.cloneNode(true));});
var span=0;
function measure(){var c=qs.children;span=c[n].offsetLeft-c[0].offsetLeft;}
requestAnimationFrame(measure);addEventListener('resize',measure);
var lastX=0;
qs.addEventListener('scroll',function(){
  var sl=qs.scrollLeft,dir=sl-lastX;lastX=sl;
  if(span>0){
    if(sl>=span){qs.scrollLeft=sl-span;lastX=qs.scrollLeft;}
    else if(sl<=0&&dir<0){qs.scrollLeft=sl+span;lastX=qs.scrollLeft;}
  }
  var i=Math.round(qs.scrollLeft/310)%n;if(i<0)i+=n;
  qd.forEach(function(d,j){d.classList.toggle('el-on',j===i)});
},{passive:true});
function step(dx){
  if(span>0){
    if(dx<0&&qs.scrollLeft-310<0){qs.scrollLeft+=span;}
    if(dx>0&&qs.scrollLeft+310>2*span){qs.scrollLeft-=span;}
  }
  qs.scrollBy({left:dx,behavior:'smooth'});
}
var bl=document.querySelector('.el-qarr-l'),br=document.querySelector('.el-qarr-r');
if(bl)bl.addEventListener('click',function(){step(-310)});
if(br)br.addEventListener('click',function(){step(310)});})();


document.querySelectorAll('details.el-acc').forEach(function(d){d.addEventListener('toggle',function(){d.classList.toggle('el-open',d.open);});});})();
